import { render, staticRenderFns } from "./CgTaskManage.vue?vue&type=template&id=2fe530cf&scoped=true"
import script from "./CgTaskManage.vue?vue&type=script&lang=js"
export * from "./CgTaskManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe530cf",
  null
  
)

export default component.exports